// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner-module--spinner--21749","spin":"LoadingSpinner-module--spin--3b700"};